/* 🤖 this file was generated by svg-to-ts */
export const DfIconAccomplishment16: {
  name: 'accomplishment-16';
  data: string;
} = {
  name: 'accomplishment-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m6 13 1-2h-.525a2 2 0 0 1-1.957-1.587l-1.479-7A2 2 0 0 1 4.996 0h5.778a2 2 0 0 1 1.957 2.413l-1.48 7A2 2 0 0 1 9.296 11H9l1 2h1.5a1.5 1.5 0 0 1 0 3h-7a1.5 1.5 0 0 1 0-3zM3.408 9h-.98a2 2 0 0 1-1.98-1.717l-.428-3A2 2 0 0 1 1.995 2c0 .204.022.412.066.62l.296 1.4A.5.5 0 0 0 2 4.5v2a.5.5 0 0 0 .5.5h.486zm8.953 0 .423-2h.716a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-.083l.292-1.38a3 3 0 0 0 .065-.62H14a2 2 0 0 1 1.98 2.283l-.429 3A2 2 0 0 1 13.571 9z" fill-rule="evenodd"/></svg>`
};
